import React from 'react';
import Button from '@mui/material/Button';
import './MuiButton.scss';
import { CircularProgress } from '@mui/material';

function MuiButton({
    variant,
    name,
    className,
    sx,
    loading,
    disabled,
    endIcon,
    ...props
}: any) {
    return (
        <Button
            variant={variant}
            name={name}
            className="mui-btn"
            {...props}
            sx={{ ...sx, textTransform: 'none' }}
            disabled={disabled ? disabled : loading}
            endIcon={
                endIcon ? (
                    endIcon
                ) : loading ? (
                    <CircularProgress size={13} color="inherit"/>
                ) : null
            }
        >
            {name}
        </Button>
    );
}

export default MuiButton;
